module.exports = __webpack_public_path__ + "img/slider6.460fdd9b.png";